import axios from 'supports/api';

/**
 * Opens a PDF ('order' | 'invoice' | 'receipt' | 'po' | 'attendance'; a
 * receipt takes the payment id, a po the PO id, an attendance sheet the
 * program id plus `params` { sessions, lecturer, module }, the others the
 * transaction id) in a new tab, through a 60-second link from
 * POST /v2/documents/token. The tab opens before the request so the browser
 * still counts the click and does not block it.
 * Resolves true once the tab is on its way to the PDF.
 */
export default async (kind, id, params) => {
  const tab = window.open('', '_blank');

  if (!tab) {
    alert('Pop-up blocked. Allow pop-ups for this site to open PDFs.');
    return false;
  }
  tab.opener = null;

  try {
    const { data } = await axios.post('/v2/documents/token', {
      kind,
      id,
      params,
    });
    tab.location.href = `${process.env.REACT_APP_BASE_URL}${data.data.url}`;
    return true;
  } catch (err) {
    tab.close();
    alert(err?.response?.data?.message || 'Could not open the document');
    return false;
  }
};
